import React from 'react'
interface Props {
  sourceLanguage: string
  targetLanguage: string
  translationExamples: {
    source: string
    target: string
  }[]
}

const TranslationExamples: React.FC<Props> = ({
  translationExamples,
  sourceLanguage,
  targetLanguage
}) => {
  return (
    <section>
      <div className="max-desktop-width  |  mx-auto py-12 px-5 lg:px-6 lg:py-22">
        <header
          className="text-center  |  mb-8 mx-auto "
          style={{ maxWidth: 784 }}
        >
          <h2 className="h3 font-medium">
            Commonly spoken {sourceLanguage} to {targetLanguage} phrases
          </h2>
        </header>
        <div className="flex">
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-y-6 gap-x-10 align-middle | max-w-4xl | mx-auto">
            {translationExamples.map((example, idx) => (
              <li key={`${idx}-example`}>
                <p className="text-paragraph-3 font-medium">{example.source}</p>
                <p className="text-paragraph-3">{example.target}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  )
}

export default TranslationExamples
